import { render, staticRenderFns } from "./productFLowSpeedRules.vue?vue&type=template&id=e8484c12&scoped=true"
import script from "./productFLowSpeedRules.vue?vue&type=script&lang=js"
export * from "./productFLowSpeedRules.vue?vue&type=script&lang=js"
import style0 from "./productFLowSpeedRules.vue?vue&type=style&index=0&id=e8484c12&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8484c12",
  null
  
)

export default component.exports